module.exports = __webpack_public_path__ + "97571edd3f343154cfd4f50e88e2cea1.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/coh_image_mobile.jpg
// module id = 296
// module chunks = 0